module.exports = __webpack_public_path__ + "img/max6.24a3c8bd.jpg";